import { StyleSheet } from 'react-native';
import type { Theme } from '../../../src/theme/getTheme';

/**
 * Bracket styles (specs/champions-league, Story 6).
 *
 * Rounds stack vertically and the page scrolls as ONE region. A horizontally-scrolling
 * classic bracket does not survive a phone width at 5 rounds, and nesting a horizontal
 * scroll inside the shell's vertical one is the nested-scroll trap the working agreement
 * calls out. State treatments mirror the picks and standings screens.
 */
export const getTournamentBracketStyles = (theme: Theme) =>
  StyleSheet.create({
    screen: {
      flex: 1,
      backgroundColor: theme.background.primary,
    },
    listContent: {
      paddingHorizontal: 12,
      paddingTop: 12,
      paddingBottom: 32,
    },
    round: {
      marginBottom: 24,
    },
    roundHeader: {
      flexDirection: 'row',
      alignItems: 'center',
      gap: 8,
      marginBottom: 10,
      marginLeft: 4,
    },
    roundLabel: {
      fontSize: theme.typography.h3.fontSize,
      fontWeight: theme.typography.h3.fontWeight,
      color: theme.black,
    },
    roundRule: {
      flex: 1,
      height: 1,
      backgroundColor: theme.gray[200],
    },
    tie: {
      marginBottom: 12,
      borderRadius: 16,
      overflow: 'hidden',
      backgroundColor: theme.background.cardElevated,
    },
    tieMeta: {
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'space-between',
      paddingHorizontal: 12,
      paddingTop: 10,
      paddingBottom: 2,
    },
    tieMetaText: {
      fontSize: 11,
      fontWeight: '700',
      color: theme.gray[500],
      textTransform: 'uppercase',
      letterSpacing: 0.4,
    },
    legLabel: {
      fontSize: 11,
      fontWeight: '600',
      color: theme.gray[400],
      marginLeft: 16,
      marginTop: 8,
    },
    emptyRound: {
      paddingVertical: 18,
      borderRadius: 16,
      borderWidth: 1,
      borderStyle: 'dashed',
      borderColor: theme.gray[300],
      alignItems: 'center',
    },
    emptyRoundText: {
      fontSize: 12,
      color: theme.gray[400],
      fontWeight: '600',
    },
    centerWrap: {
      flex: 1,
      alignItems: 'center',
      justifyContent: 'center',
      paddingHorizontal: 32,
      paddingBottom: 48,
    },
    emptyMonkey: { width: 100, height: 100, marginBottom: 16 },
    stateTitle: {
      fontSize: theme.typography.h3.fontSize,
      fontWeight: theme.typography.h3.fontWeight,
      color: theme.black,
      marginBottom: 8,
      textAlign: 'center',
    },
    stateSubtitle: {
      fontSize: theme.typography.bodySmall.fontSize,
      color: theme.gray[500],
      textAlign: 'center',
      lineHeight: 20,
      marginBottom: 24,
    },
    retryButton: {
      paddingHorizontal: 24,
      paddingVertical: 10,
      borderRadius: 20,
      backgroundColor: theme.primary,
    },
    retryLabel: { fontSize: 14, fontWeight: '700', color: theme.onPrimary },
    skeletonRow: {
      height: 96,
      borderRadius: 16,
      backgroundColor: theme.background.cardElevated,
      marginHorizontal: 12,
      marginTop: 12,
      opacity: 0.5,
    },
  });
